export const API_URL = process.env.REACT_APP_API_URL;
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL;
//CONDITIONS
export const PRIVACY_POLICY_URL = `/privacy-policy-sapheer-3.pdf`;
export const CONDITION_SAPHEER_LINK = `/cgs---sapheer---paynovate.pdf`;
export const CONDITION_LINKCY_LINK = `/cgs---sapheer---paynovate.pdf`;
